import { FormTextField, styled } from "@periplus/ui-library";

export default styled(FormTextField)(({ theme }) =>
({
    "& .MuiInputBase-root": {
        backgroundColor: "white"
    }
})
);
